import Termly from 'termly-namespace'

import { eventConsent } from 'utils/events'

import {
  unblockAll,
  unblockByCategory,
} from 'utils/unblockers'

import { ALLOW_ALL_CONSENT } from 'constants/categories'


/**
 * @param {object} [args]
 * @param {string[]} [args.categories] - when omitted, everything is released
 * @param {boolean} [args.isTemporary] - release what is on the page now but
 *   record nothing, for callers that unblock without taking a consent
 */
export default function enableConsentScripts({ categories, isTemporary } = {}) {
  // eslint-disable-next-line eqeqeq
  if ( categories == null ) {
    unblockAll()
  } else {
    unblockByCategory(categories)
  }

  if ( !isTemporary ) {
    // This sweep is the only one a manually-marked tag ever gets, and a
    // single-page app has no page load to run it again. Recording the
    // decision lets the unblock observer reapply it to the tags that show up
    // later.
    //
    // A missing `categories` means everything was released, which is broader
    // than any list of ids, so it has to be recorded as missing rather than
    // filled in with the known categories.
    //
    Termly.setReleaseDecision({ categories })
  }

  const consentCategories = categories ?? Object.keys(ALLOW_ALL_CONSENT)

  document.dispatchEvent(eventConsent(consentCategories))
}
